import React from 'react';
import { BookOpen, Users, Video, Clock, Star, Shield } from 'lucide-react';
import Container from '../ui/Container';

const features = [
  {
    icon: Users,
    title: 'Expert Teachers',
    description: 'Learn from qualified and experienced teachers in your field',
    color: 'text-blue-600',
  },
  {
    icon: Video,
    title: 'Live Sessions',
    description: 'Interactive one-on-one video sessions for personalized learning',
    color: 'text-purple-600',
  },
  {
    icon: Clock,
    title: 'Flexible Schedule',
    description: 'Book sessions at times that work best for you',
    color: 'text-green-600',
  },
  {
    icon: BookOpen,
    title: 'Any Subject',
    description: 'Wide range of subjects and topics to choose from',
    color: 'text-red-600',
  },
  {
    icon: Star,
    title: 'Quality Assured',
    description: 'All teachers are vetted and reviewed by our team',
    color: 'text-yellow-600',
  },
  {
    icon: Shield,
    title: 'Secure Platform',
    description: 'Safe and secure environment for online learning',
    color: 'text-indigo-600',
  },
];

const FeatureCard = ({ icon: Icon, title, description, color }) => {
  return (
    <div className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer">
      <div className={`${color} mb-6`}>
        <Icon className="h-8 w-8" />
      </div>
      <h3 className="text-xl font-semibold mb-3 group-hover:text-indigo-600 transition-colors">
        {title}
      </h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const FeatureSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <Container>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-bold mb-6">Why Choose AcademiaHub?</h2>
          <p className="text-xl text-gray-600">
            We provide the tools and platform you need for effective one-on-one learning
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FeatureSection;